import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '../../../../components/Layout/Layout';
import PaymentOrders from '../../../../components/Finances/PaymentOrders/PaymentOrders';
import WithAlert from '../../../../hoc/WithAlert';
// import PaymentsBankCardChangesAlert from '../../../../components/Finances/PaymentsBankCardsChangesAlert';

const FinancesInfoPage = ({ history, showAlert }) => {
  return (
    <Layout className="finances-order-page" formattedTitle="pages.payments.title">
      <Layout.Col>
        <h3 className="page-title">
          <FormattedMessage id="payments.orders.title" defaultMessage="Payments order" />
        </h3>
        {/* {hasRUBankCards ? <PaymentsBankCardChangesAlert /> : null} */}
        <PaymentOrders history={history} isForm showAlert={showAlert} />
      </Layout.Col>
    </Layout>
  );
};

export default WithAlert(FinancesInfoPage);
